(() => {
  if (window.d32StorefrontReady) return;
  window.d32StorefrontReady = true;
  const triggers = new WeakMap();
  const dialogs = '[data-d32-menu-dialog], [data-d32-search-dialog]';
  const syncLock = () => document.documentElement.classList.toggle('d32-lock-scroll', !!document.querySelector('dialog.d32[open]'));
  function close(dialog) { if (dialog?.open) dialog.close(); }
  function open(dialog, trigger) {
    if (!dialog?.showModal) return false;
    document.querySelectorAll(dialogs).forEach(other => { if (other !== dialog) close(other); });
    triggers.set(dialog, trigger);
    dialog.showModal();
    trigger?.setAttribute('aria-expanded', 'true');
    syncLock();
    if (dialog.matches('[data-d32-search-dialog]')) dialog.querySelector('input[type="search"]')?.focus();
    return true;
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-d32-open-menu], [data-d32-open-search]');
    if (trigger) {
      const header = trigger.closest('[data-d32-header]');
      const selector = trigger.hasAttribute('data-d32-open-menu') ? '[data-d32-menu-dialog]' : '[data-d32-search-dialog]';
      if (open(header?.querySelector(selector), trigger)) event.preventDefault();
    }
    if (event.target.closest('[data-d32-close-dialog]')) close(event.target.closest('dialog'));
    if (event.target.matches('dialog.d32')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(event.target);
    }
    document.querySelectorAll('.d32-desktop-nav details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.d32-nav-details[open]').forEach(details => { details.open = false; });
  });
  function bind(scope) {
    scope.querySelectorAll(dialogs).forEach(dialog => {
      if (dialog.dataset.d32Bound) return;
      dialog.dataset.d32Bound = 'true';
      dialog.addEventListener('close', () => {
        const trigger = triggers.get(dialog);
        trigger?.setAttribute('aria-expanded', 'false');
        syncLock();
        if (trigger?.isConnected) trigger.focus();
      });
    });
  }
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:section:unload', () => queueMicrotask(syncLock));
  window.matchMedia('(min-width:900px)').addEventListener('change', event => {
    if (event.matches) document.querySelectorAll(dialogs).forEach(close);
  });
  bind(document);
})();
